export default function opacify(color, opacity) {
    let o = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + o.toString(16).toUpperCase();
}